import {
  CreateTicket,
  SingleFindEvent,
} from "../redux/features/event/event.types";
import { PayoutCurrency } from "../redux/features/payment/payment.types";
import { currencyShorts } from "./constants";
import { formatToCurrency } from "./helpers";

const getPaidTickets = (tickets?: CreateTicket[]) => {
  return (
    tickets?.filter(
      (ticket) =>
        ticket.ticketType === "paid" &&
        Number(ticket.price) > 0 &&
        !!ticket.currency,
    ) ?? []
  );
};

export const getFindEventDisplayCurrency = (
  event: Pick<SingleFindEvent, "currency" | "tickets">,
): PayoutCurrency => {
  const paidTickets = getPaidTickets(event.tickets);

  if (paidTickets.length === 0) return event.currency ?? "NGN";

  const cheapestTicket = paidTickets.reduce((cheapest, ticket) => {
    return Number(ticket.price) < Number(cheapest.price) ? ticket : cheapest;
  }, paidTickets[0]);

  return cheapestTicket.currency ?? event.currency ?? "NGN";
};

export const getFindEventPriceText = (event: SingleFindEvent) => {
  if ((event.price ?? 0) <= 0) return "Free";

  return `From ${formatToCurrency(event.price ?? 0, {
    currency: currencyShorts[getFindEventDisplayCurrency(event)],
  })}`;
};

export const getWebsiteEventCardPriceText = (event: SingleFindEvent) => {
  if ((event.price ?? 0) <= 0) return "Free";

  const formattedPrice = formatToCurrency(event.price, {
    currency: currencyShorts[getFindEventDisplayCurrency(event)],
  });

  const hasMultipleTicketPrices =
    (event.averagePrice ?? event.price) !== event.price;

  return hasMultipleTicketPrices ? `From ${formattedPrice}` : formattedPrice;
};
